import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component( {
    selector: 'his-display-weblink',
    templateUrl: './his-display-weblink.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisDisplayWeblinkComponent {
    // value ist uebergebener Wert

    /*
     * Fehlt http:// oder https:// werden diese hinzugefuegt und in der url gespeichert,
     * sonst value == url
     */
    value: string;
    url: string;

    @Input( 'value' )
    set _value_( val: string ) {
        this.value = val;
        if ( !val ) {
            this.url = null;
            return;
        }
        // Substring der Übergebenen Adresse, getrennt da https und http unterschiedlich betrachtet
        let startOfValueHttp = val.substring( 0, 7 );
        let startOfValueHttps = val.substring( 0, 8 );
        // Ueberprueft ob http:// oder https:// am Anfang des Link stehen.
        if ( !( startOfValueHttp === 'http://' || startOfValueHttps === 'https://' ) ) {
            // Wenn nicht wird https:// hinzugefuegt
            this.url = 'https://' + val;
        } else {
            // Besitzt der Link bereits http:// oder https:// dann wird dieser so uebernommen
            this.url = val;
        }
    }
}
